// actions.js
import {
  FETCH_BRANDS_REQUEST,
  FETCH_BRANDS_SUCCESS,
  FETCH_BRANDS_FAILURE,
  DELETE_BRANDS_REQUEST,
  DELETE_BRANDS_FAILURE,
  DELETE_BRANDS_SUCCESS,
  FETCH_BRAND_REQUEST,
  FETCH_BRAND_SUCCESS,
  FETCH_BRAND_FAILURE,
  UPDATE_BRANDS_REQUEST,
  UPDATE_BRANDS_SUCCESS,
  UPDATE_BRANDS_FAILURE,
  CLEAR_BRAND_ERRORS,
  CLEAR_BRAND_SUCCESS,
} from './actionTypes';

export const fetchBrandsRequest = () => ({
  type: FETCH_BRANDS_REQUEST,
});

export const fetchBrandsSuccess = (projects) => ({
  type: FETCH_BRANDS_SUCCESS,
  payload: projects,
});

export const fetchBrandsFailure = (error) => ({
  type: FETCH_BRANDS_FAILURE,
  payload: error,
});

export const fetchBrandRequest = (id) => ({
  type: FETCH_BRAND_REQUEST,
  payload: id
});

export const fetchBrandSuccess = (project) => ({
  type: FETCH_BRAND_SUCCESS,
  payload: project,
});

export const fetchBrandFailure = (error) => ({
  type: FETCH_BRAND_FAILURE,
  payload: error,
});

export const updateBrandRequest = (project, navigate) => ({
  type: UPDATE_BRANDS_REQUEST,
  payload: { project, navigate }
});

export const updateBrandSuccess = () => ({
  type: UPDATE_BRANDS_SUCCESS,
});

export const updateBrandFailure = (error) => ({
  type: UPDATE_BRANDS_FAILURE,
  payload: error,
});

export const deleteBrandRequest = (id) => ({
  type: DELETE_BRANDS_REQUEST,
  payload: id
});

export const deleteBrandSuccess = (id) => ({
  type: DELETE_BRANDS_SUCCESS,
  payload: id,
});

export const deleteBrandFailure = (error) => ({
  type: DELETE_BRANDS_FAILURE,
  payload: error,
});

export const clearBrandErrors = () => ({
  type: CLEAR_BRAND_ERRORS,
});

export const clearBrandSuccess = () => ({
  type: CLEAR_BRAND_SUCCESS,
});